import React from "react";
import { Card } from "@material-ui/core";
import Overview from "./overview";
import { makeStyles } from "@material-ui/styles";

const useStyle = makeStyles((theme) => ({
  root: {
    width: "98.5%",
    height: "100%",
  },
  card: {
    width: "100%",
    // height: "10rem",
    backgroundColor: "#f8f8f6",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    // boxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    // WebkitBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    // MozBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    boxShadow: "unset",
    height: "9rem",
    maxHeight: "100%",
  },
  cardapi: {
    width: "100%",
    backgroundColor: "#FFFFFF",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    flexDirection: "column",
    boxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    borderRadius: 8,
    marginTop: "0.5rem",
    marginBottom: "0.1rem",
    minHeight: "100%",
    maxHeight: "auto",
  },
  admin: {
    width: "100%",
    // height: "auto",
    backgroundColor: "#f8f8f8",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    flexDirection: "column",
    borderRadius: 8,
    marginTop: "0.2rem",
    marginBottom: "0.1rem",
    // minHeight: "100%",
    maxHeight: "auto",
    boxShadow: "unset",
    overflow: "unset",
  },
}));

const Apikey = ({
  children,
  role,
  choice,
  state,
  setstate,
  sum,
  setSum,
  setloading,
}) => {
  const classes = useStyle();

  return (
    <div className={classes.root}>
      <Card className={classes.card}>
        <Overview
          role={role}
          choice={choice}
          state={state}
          setstate={setstate}
          sum={sum}
          setSum={setSum}
          setloading={setloading}
        />
      </Card>

      <Card
        className={role === "Administrator" ? classes.admin : classes.admin}
      >
        {children}
      </Card>
    </div>
  );
};

export default Apikey;
